import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//text-block-3.twig
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { ButtonAdapter, Content, Headline, LazyImageAdapter, LinkAdapter, ListAdapter } from '@miro-site/components_utils';
import { Box, Section, Mobile, Desktop } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box).attrs({
  $py: [0, null],
  $px: [20, null],
  $styles: {
    maxWidth: [null, 1120]
  }
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Wrapper",
  componentId: "sc-lcakqf-0"
})(["margin:auto;position:relative;*,*:before,&:after{box-sizing:border-box;}"]);
var Description = styled(Box).attrs({
  $mt: [16],
  $styles: {
    maxWidth: [null, 550]
  }
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Description",
  componentId: "sc-lcakqf-1"
})([""]);
var Title = styled(Box).attrs({
  $styles: {
    maxWidth: [null, 740]
  }
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Title",
  componentId: "sc-lcakqf-2"
})([""]);
var Elements = styled(Box).attrs(function (props) {
  var $bottomOffset = props.$bottomOffset;
  var bottomOffset = [null, 80];

  if ($bottomOffset === 'small') {
    bottomOffset = [40, 80];
  }

  if ($bottomOffset === 'big') {
    bottomOffset = [64, 120];
  }

  var styles = {
    $mb: bottomOffset,
    $styles: {
      textAlign: ['left', props.$isCentered ? 'center' : 'left']
    }
  };
  return styles;
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Elements",
  componentId: "sc-lcakqf-3"
})(["", ""], function (_ref) {
  var $isCentered = _ref.$isCentered;
  return $isCentered && css(["", ",", "{margin-left:auto;margin-right:auto;}"], Title, Description);
});
var Row = styled(Box).attrs({
  $my: [null, 0],
  $mx: [null, -10]
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Row",
  componentId: "sc-lcakqf-4"
})(["display:flex;flex-wrap:wrap;flex-direction:row;justify-content:space-between;position:relative;z-index:3;"]);
var ImageContainer = styled.div.withConfig({
  displayName: "TextBlockWithScrollingItems__ImageContainer",
  componentId: "sc-lcakqf-5"
})([""]);
var Col = styled(Box).attrs({
  $pt: [null, 0],
  $py: [null, 10]
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Col",
  componentId: "sc-lcakqf-6"
})(["", " &:nth-of-type(1){width:33.33%;flex:0 0 33.33%;", ";}&:nth-of-type(2){width:58.33%;flex:0 0 58.33%;", ";}"], function (_ref2) {
  var $isRtl = _ref2.$isRtl,
      theme = _ref2.theme;
  return $isRtl && css(["&:nth-of-type(1){order:2;}&:nth-of-type(2){order:1;}", "{float:right;", "}"], ImageContainer, theme.mq.small(css(["float:none;"])));
}, function (_ref3) {
  var theme = _ref3.theme;
  return css(["", ""], theme.mq.small(css(["width:100%;flex:0 0 100%;order:2;"])));
}, function (_ref4) {
  var theme = _ref4.theme;
  return css(["", ""], theme.mq.small(css(["width:100%;flex:0 0 100%;order:1;"])));
});
var Item = styled(Box).attrs({
  $pt: [null, 120],
  $styles: {
    opacity: [1, 0.2]
  }
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Item",
  componentId: "sc-lcakqf-7"
})(["transition:opacity 250ms linear;& + &{", ";}&.is-active{opacity:1;}"], function (_ref5) {
  var theme = _ref5.theme;
  return css(["", " ", " ", " ", ""], theme.mq.small(css(["margin-top:", ";"], theme.multipliers.small(64))), theme.mq.mediumDown(css(["padding-top:", ";"], theme.multipliers.mediumDown(240))), theme.mq.mediumUp(css(["padding-top:", ";"], theme.multipliers.mediumUp(240))), theme.mq.large(css(["padding-top:", ";"], theme.multipliers.large(240))));
});
var ItemSubtitle = styled(Box).attrs({
  $mb: 16
}).withConfig({
  displayName: "TextBlockWithScrollingItems__ItemSubtitle",
  componentId: "sc-lcakqf-8"
})(["", ""], function (_ref6) {
  var $isHidden = _ref6.$isHidden;
  return $isHidden && css(["display:none;"]);
});
var ImageWrapper = styled(Box).attrs(function (props) {
  var styles = {
    $mb: [16, null]
  };

  if (props.$isBig) {
    styles.$styles = {
      width: [null, 800],
      height: [null, 645],
      maxWidth: ['100%', null]
    };
  } else {
    styles.$styles = {
      width: [null, 645],
      height: [null, 645]
    };
  }

  return styles;
}).withConfig({
  displayName: "TextBlockWithScrollingItems__ImageWrapper",
  componentId: "sc-lcakqf-9"
})(["position:relative;"]);
var Image = styled(Box).attrs({
  $styles: {
    borderRadius: 8
  }
}).withConfig({
  displayName: "TextBlockWithScrollingItems__Image",
  componentId: "sc-lcakqf-10"
})(["width:auto;height:auto;max-width:100%;max-height:100%;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;transition:opacity 250ms linear;overflow:hidden;&.is-active{opacity:1;}", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return css(["", ""], theme.mq.small(css(["opacity:1;position:relative;"])));
});
var StartTrigger = styled(Box).attrs({
  $styles: {
    height: [null, 120]
  }
}).withConfig({
  displayName: "TextBlockWithScrollingItems__StartTrigger",
  componentId: "sc-lcakqf-11"
})(["position:absolute;left:0;right:0;z-index:-1;"]);

function initTextBlock3(startTrigger, endTrigger, imageWrapper, images, items) {
  ScrollTrigger.create({
    trigger: imageWrapper,
    start: function start() {
      var startTriggerHeight = startTrigger.getBoundingClientRect().height;
      return startTriggerHeight + ' ' + startTriggerHeight * 2;
    },
    end: function end() {
      var lastItem = items[items.length - 1];
      var lastItemHeight = lastItem.getBoundingClientRect().height;
      return 'bottom ' + lastItemHeight;
    },
    endTrigger: endTrigger,
    pin: true
  });
  document.addEventListener('wistia_loaded', function () {
    ScrollTrigger.refresh(true);
  });
  document.addEventListener('lazyloaded', function () {
    ScrollTrigger.refresh(true);
  });
  images.forEach(function (img, i) {
    var item = items[i];
    gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: 'top ' + startTrigger.getBoundingClientRect().height,
        end: 'bottom ' + startTrigger.getBoundingClientRect().height,
        onEnter: function onEnter() {
          toggleActive([items[i], images[i]]);
        },
        onEnterBack: function onEnterBack() {
          toggleActive([items[i], images[i]]);
        },
        onLeave: function onLeave() {
          toggleActive([items[i], images[i]], i === items.length - 1);
        },
        onLeaveBack: function onLeaveBack() {
          toggleActive([items[i], images[i]], i === 0);
        }
      }
    });
  });

  function toggleActive(elements, toggle) {
    var enable = typeof toggle !== 'undefined' ? !!toggle : true;
    elements.forEach(function (el) {
      if (enable) {
        el.classList.add('is-active');
      } else {
        el.classList.remove('is-active');
      }
    });
  }
}

var TextBlockWithScrollingItems = function TextBlockWithScrollingItems(_ref8) {
  var _ref8$intro = _ref8.intro,
      intro = _ref8$intro === void 0 ? {} : _ref8$intro,
      items = _ref8.items,
      big_image = _ref8.big_image,
      rtl = _ref8.rtl,
      _ref8$id = _ref8.id,
      id = _ref8$id === void 0 ? '' : _ref8$id;
  var theme = useTheme();
  var animationRef = React.useRef(null);
  var animationStartPoint = React.useRef(null);
  var animationEndPoint = React.useRef(null);
  React.useEffect(function () {
    var isInitialized = false;
    var isMobile = window.innerWidth <= theme.breakpoints.small;

    var isAllSet = function isAllSet() {
      return !isMobile || animationRef.current || animationStartPoint.current || animationEndPoint.current;
    };

    if (!isAllSet()) {
      return;
    }

    init();
    window.addEventListener('resize', init);

    function init() {
      if (!isInitialized && isAllSet()) {
        var animatedElement = animationRef.current;
        var startPointElement = animationStartPoint.current;
        var endPointElement = animationEndPoint.current;

        if (!animatedElement || !startPointElement || !endPointElement) {
          return;
        }

        var imageWrapper = animatedElement.querySelectorAll(ImageWrapper.toString())[0];
        if (!imageWrapper) return;
        var images = animatedElement.querySelectorAll(Image.toString());

        var _items = animatedElement.querySelectorAll(Item.toString());

        initTextBlock3(startPointElement, endPointElement, imageWrapper, images, _items);
        isInitialized = true;
      }

      return window.removeEventListener('resize', init);
    }
  }, [animationRef, animationStartPoint, animationEndPoint, items]);
  var headline = intro.headline,
      description = intro.description;
  return /*#__PURE__*/_jsx(Section, {
    id: id,
    "data-place": "Text Block Scrolling Section",
    type: "large",
    $styles: {
      overflow: 'hidden'
    },
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [((headline === null || headline === void 0 ? void 0 : headline.text) || (description === null || description === void 0 ? void 0 : description.html)) && /*#__PURE__*/_jsxs(Elements, {
        $isCentered: intro.align === 'center',
        $bottomOffset: headline !== null && headline !== void 0 && headline.text ? description !== null && description !== void 0 && description.html ? 'big' : 'small' : undefined,
        children: [(headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
          size: headline.size || 'mid',
          tag: headline.tag || 'h2'
        })), (description === null || description === void 0 ? void 0 : description.html) && /*#__PURE__*/_jsx(Description, {
          children: /*#__PURE__*/_jsx(Content, _objectSpread({}, description))
        })]
      }), /*#__PURE__*/_jsx(Desktop, {
        ref: animationRef,
        $block: true,
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            $isRtl: rtl === '1',
            children: (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_jsx("div", {
              children: items.map(function (item, index) {
                var _item$subtitle, _item$list;

                var isFirstItem = index === 0;
                var itemSubtitleSize = ((_item$subtitle = item.subtitle) === null || _item$subtitle === void 0 ? void 0 : _item$subtitle.size) || 'mid';
                return /*#__PURE__*/_jsxs(Item, {
                  "data-scroll-item-position": index,
                  className: isFirstItem ? 'is-active' : '',
                  children: [item.subtitle && /*#__PURE__*/_jsx(ItemSubtitle, {
                    children: isFirstItem ? /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, item.subtitle), {}, {
                      size: headline ? 'small' : itemSubtitleSize,
                      tag: headline ? 'h3' : itemSubtitleSize == 'small' ? 'h3' : 'h2'
                    })) : /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, item.subtitle), {}, {
                      size: item.subtitle.size || 'tiny',
                      tag: item.subtitle.tag || 'h3'
                    }))
                  }), item.content && /*#__PURE__*/_jsx(Content, _objectSpread({}, item.content)), ((_item$list = item.list) === null || _item$list === void 0 ? void 0 : _item$list.length) > 0 && /*#__PURE__*/_jsx(ListAdapter, {
                    list: item.list,
                    list_type: item.list_type
                  }), item.button && /*#__PURE__*/_jsx(Box, {
                    $mt: 32,
                    children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({}, item.button), {}, {
                      type: "transparent"
                    }))
                  }), item.link && /*#__PURE__*/_jsx(Box, {
                    $mt: 24,
                    children: /*#__PURE__*/_jsx(LinkAdapter, _objectSpread({}, item.link))
                  }), index == items.length - 1 && /*#__PURE__*/_jsx("div", {
                    className: "__end",
                    ref: animationEndPoint
                  })]
                }, index);
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            $isRtl: rtl === '1',
            children: /*#__PURE__*/_jsx(ImageContainer, {
              children: /*#__PURE__*/_jsx(ImageWrapper, {
                $isBig: big_image,
                children: items.map(function (item, index) {
                  var _src;

                  var isFirstItem = index === 0;
                  var imageSrc = (_src = item.image.src) !== null && _src !== void 0 ? _src : '';
                  return item.image && /*#__PURE__*/_jsx(Image, {
                    className: isFirstItem ? 'is-active' : '',
                    children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                      assets: item.image
                    })
                  }, imageSrc + index);
                })
              })
            })
          }), /*#__PURE__*/_jsx(StartTrigger, {
            ref: animationStartPoint
          })]
        })
      }), /*#__PURE__*/_jsx(Mobile, {
        $block: true,
        children: items.map(function (item, index) {
          var _item$subtitle2, _src2, _item$list2;

          var itemSubtitleSize = ((_item$subtitle2 = item.subtitle) === null || _item$subtitle2 === void 0 ? void 0 : _item$subtitle2.size) || 'mid';
          var imageSrc = (_src2 = item.image.src) !== null && _src2 !== void 0 ? _src2 : '';
          return /*#__PURE__*/_jsxs(Item, {
            children: [item.subtitle && /*#__PURE__*/_jsx(ItemSubtitle, {
              children: !headline && index === 0 ? /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, item.subtitle), {}, {
                size: itemSubtitleSize,
                tag: itemSubtitleSize == 'small' ? 'h3' : 'h2'
              })) : /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, item.subtitle), {}, {
                size: headline ? 'small' : item.subtitle.size || 'tiny',
                tag: item.subtitle.tag || 'h3'
              }))
            }), item.image && /*#__PURE__*/_jsx(ImageContainer, {
              children: /*#__PURE__*/_jsx(ImageWrapper, {
                $isBig: big_image,
                children: item.image && /*#__PURE__*/_jsx(Image, {
                  children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                    assets: item.image
                  })
                }, imageSrc + index)
              })
            }), item.content && /*#__PURE__*/_jsx(Content, _objectSpread({}, item.content)), ((_item$list2 = item.list) === null || _item$list2 === void 0 ? void 0 : _item$list2.length) && /*#__PURE__*/_jsx(ListAdapter, {
              list: item.list,
              list_type: item.list_type
            }), item.button && /*#__PURE__*/_jsx(Box, {
              $mt: 32,
              children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({}, item.button), {}, {
                type: "transparent"
              }))
            }), item.link && /*#__PURE__*/_jsx(Box, {
              $mt: 24,
              children: /*#__PURE__*/_jsx(LinkAdapter, _objectSpread({}, item.link))
            })]
          }, index);
        })
      })]
    })
  });
};

export default TextBlockWithScrollingItems;